import reduxStore from 'redux/store'
import {setLoadingScreen} from "../redux/actions";

export default () => {
    const showLoadingScreen = () => setLoadingScreenShow(true);
    const hideLoadingScreen = () => setLoadingScreenShow(undefined);
    const setLoadingScreenShow = (show) => {
        reduxStore.dispatch(setLoadingScreen(!show ? undefined : true));
    }

    return {setLoadingScreenShow, hideLoadingScreen, showLoadingScreen};
}
